import { render, staticRenderFns } from "./Formulario012B.vue?vue&type=template&id=65ab808d&scoped=true"
import script from "./Formulario012B.vue?vue&type=script&lang=js"
export * from "./Formulario012B.vue?vue&type=script&lang=js"
import style0 from "./Formulario012B.vue?vue&type=style&index=0&id=65ab808d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ab808d",
  null
  
)

export default component.exports